import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "flex justify-end" };
const _hoisted_4 = {
    key: 3,
    class: "filter-divider"
};
const _hoisted_5 = {
    key: 4,
    class: "filter-bar-content",
    ref: "filterBarContent"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["top-panel-wrapper", { 'pb-2': $setup.hasGapToTable }])
    }, [
        ($props.shortcutFilterButtons && $props.shortcutFilterButtons.length > 0)
            ? (_openBlock(), _createBlock($setup["EnDataGridShortcutFilterBar"], {
                key: 0,
                "shortcut-filter-buttons": $props.shortcutFilterButtons,
                "total-count": $props.totalCount
            }, null, 8 /* PROPS */, ["shortcut-filter-buttons", "total-count"]))
            : _createCommentVNode("v-if", true),
        _renderSlot(_ctx.$slots, "headerPrepend"),
        _createVNode($setup["EnDialog"], {
            modelValue: $setup.showEditDialogComputed,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.showEditDialogComputed) = $event)),
            title: $props.editDialogTitleComputed,
            autoWidth: $props.editDialogOptions?.autoWidth,
            small: $props.editDialogOptions?.small,
            "fixed-actions": $props.fixedActions,
            onClose: $props.closeEditDialog
        }, {
            content: _withCtx(() => [
                _createVNode($setup["EnForm"], {
                    ref: "editDialogForm",
                    onSubmit: _withModifiers(() => { }, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        ($props.addingDialogIsVisible)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createCommentVNode(" @slot Placed inside a form. Uses the passed v-model to bind the form inputs. If not passed and table allows adding the editDialog is shown instead. "),
                                _renderSlot(_ctx.$slots, "addDialog")
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createCommentVNode(" @slot Placed inside a form. Uses the passed v-model to bind the form inputs. "),
                                _renderSlot(_ctx.$slots, "editDialog", {}, () => [
                                    _cache[9] || (_cache[9] = _createTextVNode(" Add 'editDialog' slot to AsyncDataGrid to fill out this form with inputs. Use an 'editedItem' bound via v-model to AsyncDataGrid's 'value' for binding the form inputs. ", -1 /* CACHED */)),
                                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                    _cache[11] || (_cache[11] = _createTextVNode(" TODO: autogenerate a basic form based on headers ", -1 /* CACHED */))
                                ])
                            ]))
                    ]),
                    _: 3 /* FORWARDED */
                }, 512 /* NEED_PATCH */),
                ($props.editDialogErrorMessage)
                    ? (_openBlock(), _createBlock($setup["EnBanner"], {
                        key: 0,
                        ref: "validationErrorRef",
                        class: "mt-5",
                        variant: "error",
                        id: "edit-dialog-error-message"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($props.editDialogErrorMessage), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */))
                    : _createCommentVNode("v-if", true)
            ]),
            actions: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    ($props.editDialogOptions?.cancelButton)
                        ? (_openBlock(), _createBlock($setup["EnButton"], {
                            key: 0,
                            height: "36px",
                            width: "100px",
                            class: "mr-3",
                            "static-id": "dialog-cancel-button",
                            onClick: $props.closeEditDialog
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('common.dataGrid.cancel')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]))
                        : _createCommentVNode("v-if", true),
                    _createVNode($setup["EnButton"], {
                        height: "36px",
                        width: "100px",
                        variant: "default",
                        disabled: $setup.editFormIsDisabledComputed,
                        "static-id": "dialog-save-button",
                        onClick: $props.saveItem
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($props.dialogSaveButtonText), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled", "onClick"])
                ])
            ]),
            _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["modelValue", "title", "autoWidth", "small", "fixed-actions", "onClose"]),
        ($props.allowDeleting)
            ? (_openBlock(), _createBlock($setup["EnDeleteDialog"], {
                key: 1,
                modelValue: $setup.showDeleteDialogComputed,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.showDeleteDialogComputed) = $event)),
                onConfirm: $props.deleteItemConfirm
            }, {
                default: _withCtx(() => [
                    ($props.editDialogErrorMessage)
                        ? (_openBlock(), _createBlock($setup["EnBanner"], {
                            key: 0,
                            class: "mt-5",
                            variant: "error",
                            id: "delete-dialog-error-message"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($props.editDialogErrorMessage), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "onConfirm"]))
            : _createCommentVNode("v-if", true),
        ($setup.filterBarIsVisible)
            ? (_openBlock(), _createBlock($setup["EnFilterBar"], {
                key: 2,
                ref: "filterBarRef",
                "show-filter-options": $props.showFilterOptions || $props.showResetFilterButton,
                "reset-individual-filter": $props.resetIndividualFilter,
                "filter-buttons": $props.filterButtons,
                "show-export-button": $props.showExportButton,
                "export-all-data": $props.exportAllData,
                columns: $props.columns,
                "show-all-columns": $setup.showAllColumns,
                "restore-default-view": $props.restoreDefaultView,
                showRestoreDefaultViewButton: $props.showRestoreDefaultViewButton,
                "reorder-columns": $props.reorderColumns,
                "toggle-visibility-column": $setup.toggleVisibilityColumn,
                "allow-adding": $props.allowAdding,
                dense: $props.dense,
                "add-item": $props.addItem,
                "export-data": $props.exportData,
                "data-grid-key": $props.dataGridKey,
                "show-columns-button": $props.showColumnsButton,
                "show-action-button": $props.showActionButton,
                onResetFilters: $setup.handleResetFilters
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                _renderList(_ctx.$slots, (slot, name) => {
                    return {
                        name: name,
                        fn: _withCtx((slotProps) => [
                            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotProps)))
                        ])
                    };
                })
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["show-filter-options", "reset-individual-filter", "filter-buttons", "show-export-button", "export-all-data", "columns", "restore-default-view", "showRestoreDefaultViewButton", "reorder-columns", "allow-adding", "dense", "add-item", "export-data", "data-grid-key", "show-columns-button", "show-action-button"]))
            : _createCommentVNode("v-if", true),
        ($setup.isDividerVisible || $setup.slots.filter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("v-if", true),
        ($setup.slots.filter || $setup.hasFilterButtons)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createCommentVNode(" @slot Used to display filters in the data grid's filter bar. "),
                _renderSlot(_ctx.$slots, "filter", {}, () => [
                    ($props.filterButtons?.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.filterButtons, (filterButton) => {
                            return (_openBlock(), _createElementBlock("span", {
                                key: filterButton.key
                            }, [
                                (filterButton.visible && filterButton.type === $setup.FilterButtonType.Select)
                                    ? (_openBlock(), _createBlock($setup["EnFilterButton"], {
                                        key: 0,
                                        class: "filter-button",
                                        modelValue: $props.filters[filterButton.key].value,
                                        "onUpdate:modelValue": ($event) => (($props.filters[filterButton.key].value) = $event),
                                        id: filterButton.id,
                                        "reset-value": $props.filters[filterButton.key].resetValue,
                                        items: filterButton.options,
                                        "selection-variant": filterButton.selectionVariant,
                                        "open-on-render": filterButton.openOnRender,
                                        "onUpdate:openOnRender": ($event) => ((filterButton.openOnRender) = $event),
                                        onInput: (newVal) => $setup.updateFilter(newVal, $props.filters[filterButton.key]),
                                        onResetFilter: ($event) => ($setup.emit('reset-filter', filterButton.key))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(filterButton.label), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "id", "reset-value", "items", "selection-variant", "open-on-render", "onUpdate:openOnRender", "onInput", "onResetFilter"]))
                                    : _createCommentVNode("v-if", true),
                                (filterButton.visible && filterButton.type === $setup.FilterButtonType.Address)
                                    ? (_openBlock(), _createBlock($setup["EnAddressSearchFilterButton"], {
                                        key: 1,
                                        class: "filter-button",
                                        modelValue: $props.filters[filterButton.key],
                                        "onUpdate:modelValue": ($event) => (($props.filters[filterButton.key]) = $event),
                                        id: filterButton.id,
                                        label: filterButton.label,
                                        hint: filterButton.hint,
                                        "is-autocomplete": filterButton.isAutocomplete,
                                        "api-url": filterButton.apiUri,
                                        "data-fields": filterButton.dataFields,
                                        properties: filterButton.properties,
                                        "display-separator": filterButton.displaySeparator,
                                        "combine-nested-filters": filterButton.combineNestedFilters,
                                        "allow-like": filterButton.allowLike,
                                        "full-value-autocomplete": filterButton.fullValueAutocomplete,
                                        "has-label": filterButton.hasLabel,
                                        "has-position": filterButton.hasPosition,
                                        "has-consumption-point-type": filterButton.hasConsumptionPointType,
                                        "has-house-number": filterButton.hasHouseNumber,
                                        "filter-type-selection": filterButton.hasFilterTypeSelection,
                                        "open-on-render": filterButton.openOnRender,
                                        "onUpdate:openOnRender": ($event) => ((filterButton.openOnRender) = $event),
                                        onResetFilter: ($event) => ($setup.emit('reset-filter', filterButton.key)),
                                        onFilterUpdated: _cache[2] || (_cache[2] = ($event) => ($setup.emit('filter-updated')))
                                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "id", "label", "hint", "is-autocomplete", "api-url", "data-fields", "properties", "display-separator", "combine-nested-filters", "allow-like", "full-value-autocomplete", "has-label", "has-position", "has-consumption-point-type", "has-house-number", "filter-type-selection", "open-on-render", "onUpdate:openOnRender", "onResetFilter"]))
                                    : _createCommentVNode("v-if", true),
                                (filterButton.visible && filterButton.type === $setup.FilterButtonType.Input)
                                    ? (_openBlock(), _createBlock($setup["EnSearchFilterButton"], {
                                        key: 2,
                                        class: "filter-button",
                                        modelValue: $props.filters[filterButton.key].value,
                                        "onUpdate:modelValue": ($event) => (($props.filters[filterButton.key].value) = $event),
                                        id: filterButton.id,
                                        hint: filterButton.hint,
                                        "no-filter-text": $setup.t('common.dataGrid.selectAll'),
                                        "filter-type-selection-visible": filterButton.hasFilterTypeSelection,
                                        "open-on-render": filterButton.openOnRender,
                                        "onUpdate:openOnRender": ($event) => ((filterButton.openOnRender) = $event),
                                        onResetFilter: ($event) => ($setup.emit('reset-filter', filterButton.key)),
                                        onFilterUpdated: _cache[3] || (_cache[3] = ($event) => ($setup.emit('filter-updated')))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(filterButton.label), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "id", "hint", "no-filter-text", "filter-type-selection-visible", "open-on-render", "onUpdate:openOnRender", "onResetFilter"]))
                                    : _createCommentVNode("v-if", true),
                                (filterButton.visible && (filterButton.type === $setup.FilterButtonType.Number || filterButton.type === $setup.FilterButtonType.Money))
                                    ? (_openBlock(), _createBlock($setup["EnNumberFilterButton"], {
                                        key: 3,
                                        class: "filter-button",
                                        modelValue: $props.filters[filterButton.key].value,
                                        "onUpdate:modelValue": ($event) => (($props.filters[filterButton.key].value) = $event),
                                        type: $props.filters[filterButton.key].filterType,
                                        "onUpdate:type": ($event) => (($props.filters[filterButton.key].filterType) = $event),
                                        id: filterButton.id,
                                        hint: filterButton.hint,
                                        "no-filter-text": $setup.t('common.dataGrid.selectAll'),
                                        "filter-type-selection-visible": filterButton.hasFilterTypeSelection,
                                        "is-money": filterButton.type === $setup.FilterButtonType.Money,
                                        "open-on-render": filterButton.openOnRender,
                                        "onUpdate:openOnRender": ($event) => ((filterButton.openOnRender) = $event),
                                        onResetFilter: ($event) => ($setup.emit('reset-filter', filterButton.key)),
                                        onFilterUpdated: _cache[4] || (_cache[4] = ($event) => ($setup.emit('filter-updated')))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(filterButton.label), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "type", "onUpdate:type", "id", "hint", "no-filter-text", "filter-type-selection-visible", "is-money", "open-on-render", "onUpdate:openOnRender", "onResetFilter"]))
                                    : _createCommentVNode("v-if", true),
                                (filterButton.visible && filterButton.type === $setup.FilterButtonType.Date)
                                    ? (_openBlock(), _createBlock($setup["EnDateFilterButton"], {
                                        key: 4,
                                        class: "filter-button",
                                        modelValue: $props.filters[filterButton.key].value,
                                        "onUpdate:modelValue": ($event) => (($props.filters[filterButton.key].value) = $event),
                                        id: filterButton.id,
                                        type: $props.filters[filterButton.key].filterType,
                                        "onUpdate:type": ($event) => (($props.filters[filterButton.key].filterType) = $event),
                                        hint: filterButton.hint,
                                        "initial-type": $props.filters[filterButton.key].resetFilterType,
                                        "filter-type-selection-visible": filterButton.hasFilterTypeSelection,
                                        "allowed-dates": filterButton.allowedDates,
                                        "open-on-render": filterButton.openOnRender,
                                        "onUpdate:openOnRender": ($event) => ((filterButton.openOnRender) = $event),
                                        onResetFilter: ($event) => ($setup.emit('reset-filter', filterButton.key)),
                                        onFilterUpdated: _cache[5] || (_cache[5] = ($event) => ($setup.emit('filter-updated')))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(filterButton.label), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "id", "type", "onUpdate:type", "hint", "initial-type", "filter-type-selection-visible", "allowed-dates", "open-on-render", "onUpdate:openOnRender", "onResetFilter"]))
                                    : _createCommentVNode("v-if", true),
                                (filterButton.visible && filterButton.type === $setup.FilterButtonType.DateMonth)
                                    ? (_openBlock(), _createBlock($setup["EnDateFilterButton"], {
                                        key: 5,
                                        class: "filter-button",
                                        modelValue: $props.filters[filterButton.key].value,
                                        "onUpdate:modelValue": ($event) => (($props.filters[filterButton.key].value) = $event),
                                        id: filterButton.id,
                                        type: $props.filters[filterButton.key].filterType,
                                        "onUpdate:type": ($event) => (($props.filters[filterButton.key].filterType) = $event),
                                        hint: filterButton.hint,
                                        "initial-type": $props.filters[filterButton.key].resetFilterType,
                                        "filter-type-selection-visible": filterButton.hasFilterTypeSelection,
                                        "allowed-dates": filterButton.allowedDates,
                                        "open-on-render": filterButton.openOnRender,
                                        "onUpdate:openOnRender": ($event) => ((filterButton.openOnRender) = $event),
                                        onResetFilter: ($event) => ($setup.emit('reset-filter', filterButton.key)),
                                        onFilterUpdated: _cache[6] || (_cache[6] = ($event) => ($setup.emit('filter-updated'))),
                                        "is-month": ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(filterButton.label), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "id", "type", "onUpdate:type", "hint", "initial-type", "filter-type-selection-visible", "allowed-dates", "open-on-render", "onUpdate:openOnRender", "onResetFilter"]))
                                    : _createCommentVNode("v-if", true),
                                (filterButton.visible && filterButton.type === $setup.FilterButtonType.Autocomplete)
                                    ? (_openBlock(), _createBlock($setup["EnAutocompleteFilterButton"], {
                                        key: 6,
                                        class: "filter-button",
                                        modelValue: $props.filters[filterButton.key].value,
                                        "onUpdate:modelValue": ($event) => (($props.filters[filterButton.key].value) = $event),
                                        "filter-type": $props.filters[filterButton.key].filterType,
                                        "onUpdate:filterType": ($event) => (($props.filters[filterButton.key].filterType) = $event),
                                        id: filterButton.id,
                                        "api-uri": filterButton.apiUri,
                                        "item-value": filterButton.itemValue,
                                        items: filterButton.items,
                                        group: filterButton.group,
                                        "on-loading-from-url": filterButton.onLoadingFromUrl,
                                        "hide-null-values": filterButton.hideNullValues,
                                        "search-expression": filterButton.searchExpression,
                                        "search-value": filterButton.searchValue,
                                        "select-expression": filterButton.selectExpression,
                                        "selected-value": $props.filters[filterButton.key].selectedValue,
                                        "display-expression": filterButton.displayExpression,
                                        "use-contains": filterButton.useContains,
                                        "no-filter-text": $setup.t(!filterButton.noFilterText ? 'common.dataGrid.selectAll' : filterButton.noFilterText),
                                        hint: filterButton.hint,
                                        "open-on-render": filterButton.openOnRender,
                                        "onUpdate:openOnRender": ($event) => ((filterButton.openOnRender) = $event),
                                        onResetFilter: ($event) => ($setup.emit('reset-filter', filterButton.key)),
                                        onFilterUpdated: _cache[7] || (_cache[7] = ($event) => ($setup.emit('filter-updated'))),
                                        clearable: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(filterButton.label), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "filter-type", "onUpdate:filterType", "id", "api-uri", "item-value", "items", "group", "on-loading-from-url", "hide-null-values", "search-expression", "search-value", "select-expression", "selected-value", "display-expression", "use-contains", "no-filter-text", "hint", "open-on-render", "onUpdate:openOnRender", "onResetFilter"]))
                                    : _createCommentVNode("v-if", true),
                                (filterButton.visible && filterButton.type === $setup.FilterButtonType.InputMultiple)
                                    ? (_openBlock(), _createBlock($setup["EnMultipleSearchFilterButton"], {
                                        key: 7,
                                        class: "filter-button",
                                        id: filterButton.id,
                                        modelValue: $props.filters[filterButton.key],
                                        "onUpdate:modelValue": ($event) => (($props.filters[filterButton.key]) = $event),
                                        "filter-type-selection-visible": filterButton.hasFilterTypeSelection,
                                        "open-on-render": filterButton.openOnRender,
                                        "onUpdate:openOnRender": ($event) => ((filterButton.openOnRender) = $event),
                                        onResetFilter: ($event) => ($setup.emit('reset-filter', filterButton.key)),
                                        onFilterUpdated: _cache[8] || (_cache[8] = ($event) => ($setup.emit('filter-updated')))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(filterButton.label), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue", "filter-type-selection-visible", "open-on-render", "onUpdate:openOnRender", "onResetFilter"]))
                                    : _createCommentVNode("v-if", true)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                ])
            ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */));
}
